import { SxProps } from "@mui/material";

export const sxLabel: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 600,
}

export const sxInput: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 400,
    fontSize: '14px'
}

export const sxError: SxProps = {
    color: '#D84141',
    fontSize: '12px'
}

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px '
}

export const sxConfirmTermButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    height: '100%'
}

export const sxCheckbox: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#4C4C4C'
    } 
}

export const sxOutlinedButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    border: '2px solid var(--Primary-01-Medium, #00995D)',
    padding: '12px 32px ',
    color: 'rgb(0,0,0,0.08)',
    '&:focus': {
        background: '#fff',
    }
}

export const sxOutlinedButtonAccessibility: SxProps = {
    ...sxOutlinedButton,
    border: '2px solid #FFFF00',
    color: '#FFFF00'
}

export const sxTermsOfUseModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: '100vh',
    maxWidth: '650px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'auto'
}

export const sxStartAdornment: SxProps = {
    fontFamily: 'Unimed-Sans',
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '21px',
}

export const sxStartAdornmentAccessibility: SxProps = {
    ...sxStartAdornment,
    color: 'white'
}

export const sxTable: SxProps = {
    borderRadius: '10px',
    width: '100%',
    maxWidth: '100vw',
    overflow: 'auto',
    '@media (max-width: 360px)': {
        maxWidth: '230px'
    },
    '@media (max-width: 320px)': {
        maxWidth: '200px'
    }
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '30%',
    minWidth: '250px',
    maxHeight: '100vh',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
    overflow: 'auto'
}

export const sxMessageTextField: SxProps = {
    "& .MuiOutlinedInput-root": {
        alignItems: 'flex-start',
        height: 'unset',
        minHeight: '150px',
        fontFamily: 'Unimed-Sans',
    },
    "& .MuiOutlinedInput-input": {
        fontFamily: 'Unimed-Sans',
        color: '#383838',
        fontSize: '14px',
    },
}